<template>
	<div class="resourcesOverview">
		<table class="villagesTable lined">
			<thead>
				<tr>
					<th translate=""><span>Деревня</span></th>
					<th class="resource"><i class="unit_wood_small_illu" tooltip="" tooltip-translate="wood"></i></th>
					<th class="resource"><i class="unit_clay_small_illu" tooltip="" tooltip-translate="clay"></i></th>
					<th class="resource"><i class="unit_iron_small_illu" tooltip="" tooltip-translate="iron"></i></th>
					<th class="resource"><i class="unit_crop_small_illu" tooltip="" tooltip-translate="crop"></i></th>
					<th translate=""><span>Торговцы</span></th>
				</tr>
			</thead>
			<tbody>
				<tr ng-repeat="village in overview | orderBy:'villageName'" ng-class="{activeVillage:activeVillageId == village.villageId}" class="activeVillage">
					<td>
						<div class="longTitle"><a clickable="setVillage(village.villageId)" class="truncated clickable">Брест</a></div>
					</td>
					<td ng-repeat="resource in village.resources track by $index" tooltip="" tooltip-class="storageTooltip" tooltip-translate="Ratio" tooltip-data="value: 23272, total: 66000">
						23272
					</td>
					<td ng-repeat="resource in village.resources track by $index" tooltip="" tooltip-class="storageTooltip" tooltip-translate="Ratio" tooltip-data="value: 9493, total: 66000">
						9493
					</td>
					<td ng-repeat="resource in village.resources track by $index" tooltip="" tooltip-class="storageTooltip" tooltip-translate="Ratio" tooltip-data="value: 15965, total: 66000">
						15965
					</td>
					<td ng-repeat="resource in village.resources track by $index" tooltip="" tooltip-class="storageTooltip" tooltip-translate="Ratio" tooltip-data="value: 49974, total: 80000">
						49974
					</td>
					<td>
						<a clickable="openMarketPlace(village.villageId)" ng-if="village.merchants.total > 0" class="clickable">20/20</a>
						<!-- ngIf: village.merchants.total <= 0 -->
					</td>
				</tr>
				<tr ng-repeat="village in overview | orderBy:'villageName'" ng-class="{activeVillage:activeVillageId == village.villageId}">
					<td>
						<div class="longTitle"><a clickable="setVillage(village.villageId)" class="truncated clickable">Глушица</a></div>
					</td>
					<td ng-repeat="resource in village.resources track by $index" tooltip="" tooltip-class="storageTooltip" tooltip-translate="Ratio" tooltip-data="value: 1153, total: 9600">
						1153
					</td>
					<td ng-repeat="resource in village.resources track by $index" tooltip="" tooltip-class="storageTooltip" tooltip-translate="Ratio" tooltip-data="value: 615, total: 9600">
						615
					</td>
					<td ng-repeat="resource in village.resources track by $index" tooltip="" tooltip-class="storageTooltip" tooltip-translate="Ratio" tooltip-data="value: 1115, total: 9600">
						1115
					</td>
					<td ng-repeat="resource in village.resources track by $index" tooltip="" tooltip-class="storageTooltip" tooltip-translate="Ratio" tooltip-data="value: 6662, total: 9600">
						6662
					</td>
					<td>
						<a clickable="openMarketPlace(village.villageId)" ng-if="village.merchants.total > 0" class="clickable">1/1</a>
						<!-- ngIf: village.merchants.total <= 0 -->
					</td>
				</tr>
				<tr ng-repeat="village in overview | orderBy:'villageName'" ng-class="{activeVillage:activeVillageId == village.villageId}">
					<td>
						<div class="longTitle"><a clickable="setVillage(village.villageId)" class="truncated clickable">Зарница</a></div>
					</td>
					<td ng-repeat="resource in village.resources track by $index" tooltip="" tooltip-class="storageTooltip" tooltip-translate="Ratio" tooltip-data="value: 6543, total: 18000">
						6543
					</td>
					<td ng-repeat="resource in village.resources track by $index" tooltip="" tooltip-class="storageTooltip" tooltip-translate="Ratio" tooltip-data="value: 5646, total: 18000">
						5646
					</td>
					<td ng-repeat="resource in village.resources track by $index" tooltip="" tooltip-class="storageTooltip" tooltip-translate="Ratio" tooltip-data="value: 5457, total: 18000">
						5457
					</td>
					<td ng-repeat="resource in village.resources track by $index" tooltip="" tooltip-class="storageTooltip" tooltip-translate="Ratio" tooltip-data="value: 16338, total: 18000">
						16338
					</td>
					<td>
						<a clickable="openMarketPlace(village.villageId)" ng-if="village.merchants.total > 0" class="clickable">6/6</a>
						<!-- ngIf: village.merchants.total <= 0 -->
					</td>
				</tr>
			</tbody>
			<tfoot>
				<tr>
					<td translate=""><span>Всего</span></td>
					<td ng-repeat="resource in total.resources track by $index">
						30967
					</td>
					<td ng-repeat="resource in total.resources track by $index">
						15754
					</td>
					<td ng-repeat="resource in total.resources track by $index">
						22537
					</td>
					<td ng-repeat="resource in total.resources track by $index">
						72974
					</td>
					<td>
						27/27
					</td>
				</tr>
			</tfoot>
		</table>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	components: {},
}
</script>